export const QA_NAME_RECONNECT_ACCOUNTS_MODAL = 'reconnectAccounts'

export const EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME = {
  account: 'account',
  action: 'action',
  type: 'type',
}

export const EMAIL_RECONNECT_ACCOUNT_TABLE_COLUMNS = {
  [EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.account]: {
    index: 0,
    name: EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.account,
    ordering_field: null,
    title: 'Modal.EmailReconnectAccountsColumnEmailKey',
    visible: true,
    width: 262,
  },
  [EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.action]: {
    index: 2,
    name: EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.action,
    ordering_field: null,
    title: 'Modal.EmailReconnectAccountsColumnActionKey',
    visible: true,
    width: 200,
  },
  [EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.type]: {
    index: 1,
    name: EMAIL_RECONNECT_ACCOUNTS_TABLE_CELL_NAME.type,
    ordering_field: null,
    title: 'Modal.EmailReconnectAccountsColumnTypeKey',
    visible: true,
    width: 200,
  },
}
